import { render, staticRenderFns } from "./DropShadowBrIcon.vue?vue&type=template&id=2697369a&"
import script from "./DropShadowBrIcon.vue?vue&type=script&lang=js&"
export * from "./DropShadowBrIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports